import { useNavigate } from '@tanstack/react-router';
import posthog from 'posthog-js';
import { useAuthStore } from '@/shared/stores/auth-store';
import { apiService } from '@/shared/services/api';
import { endpoints } from '@/shared/services/endpoints';
import { clearSessionToken } from '@/shared/services/session-token';

export function useLogout() {
  const logout = useAuthStore((s) => s.logout);
  const navigate = useNavigate();

  return function handleLogout() {
    apiService.post(endpoints.auth.logout()).catch(() => {});
    clearSessionToken();
    logout();
    posthog.reset();
    navigate({ to: '/login' });
  };
}
